import {buildAccountItemsFromConfig} from '#core/utils/intent-factory.js';
import {mergeToHierarchy} from '#core/utils/config-utils.js';

import {ApplicationConfig} from '#core/config/application-config.js';
import {EmptyMetaFactory} from '#core/application/seo/head-meta-factory.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {Account} from '../account.js';

import {myAccountPageFactory} from './my-account-page.factory';

import PALETTE_SCHEMA from './my-account-page.palette-schema.yaml';

class MyAccountPageFeature extends AbstractVisualFeature {
    get name() {
        return 'MyAccountPage';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        return myAccountPageFactory(PALETTE);
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        mergeToHierarchy(mojitoConfig, 'services.configurations', {
            MyAccountPageView: {
                documentHeadMetaFactory: EmptyMetaFactory,
                menuSections: buildAccountItemsFromConfig(ApplicationConfig.config.myAccountViewItems),
                linkMenu: {
                    showExtraItemDetails: true,
                },
            },
        });

        return super.beforeMojitoConfigBuild(mojitoConfig);
    }
}

export const MyAccountPage = new MyAccountPageFeature(Account);
